module.exports = __webpack_public_path__ + "static/img/qrcode360.4387c4bf.png";